// Breakpoints

export const breakpointDown = key => {
  switch (key) {
    case 'xs':
      return window.innerWidth < 576;

    case 'sm':
      return window.innerWidth < 768;

    case 'md':
      return window.innerWidth < 992;

    case 'lg':
      return window.innerWidth < 1200;

    default:
      return false;
  }
}

export const breakpointUp = key => {
  switch (key) {
    case 'sm':
      return window.innerWidth >= 576;

    case 'md':
      return window.innerWidth >= 768;

    case 'lg':
      return window.innerWidth >= 992;

    case 'xl':
      return window.innerWidth >= 1200;

    default:
      return false;
  }
}

// Cookies

const getDomain = () => {
  const hostNameArray = window.location.hostname.split('.');

  if (hostNameArray.length > 1) {
    return hostNameArray.slice(-2).join('.');
  }

  return window.location.hostname;
};

export const setCookie = (name, value, days) => {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${value || ''}${expires}; path=/; domain=${getDomain()}`;
};

export const getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

export const removeCookie = name => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${getDomain()}`;
};

// Toggle Loader

export const toggleLoader = ($target, state = true) => {
  if ($target.classList.contains('loading') || !state) {
    $target.classList.remove('loading');
    $target.querySelector('.spinner').remove();

    if ($target.tagName === 'BUTTON') {
      $target.removeAttribute('disabled');
    }
  } else {
    if ($target.tagName === 'BUTTON') {
      $target.setAttribute('disabled', 'disabled');
    }

    const spinner = document.createElement('div');
    spinner.classList.add('spinner');
    spinner.innerHTML = '<div></div><div></div><div></div><div></div><div></div>';

    $target.classList.add('loading');
    $target.appendChild(spinner);
  }
};
